// App.svelte takes the contract from a `/contracts/<id>` segment anywhere in
// the path and otherwise from the stored contract.
const CONTRACT_SEGMENT = /^(.*?\/contracts\/)[^/]+/;

/**
 * Where a tab continues after switching to another contract with a reload:
 * - a path with a contract segment is cut after it with the new id (a detail
 *   page of the old contract does not exist in the new one),
 * - any other page (e.g. the docs) stays as it is.
 * @param {{pathname: string, search?: string, hash?: string}} location
 * @param {string} contractId
 */
export function contractSwitchUrl(location, contractId) {
  const match = location.pathname.match(CONTRACT_SEGMENT);
  if (match) return `${match[1]}${encodeURIComponent(contractId)}`;

  return `${location.pathname}${location.search ?? ""}${location.hash ?? ""}`;
}
